(() => {
  'use strict';
  document.querySelectorAll('[data-d17-quantity]').forEach(button => {
    button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('[data-r-quantity]');
      input.value = String(Math.max(1, Math.min(99, (Number(input.value) || 1) + Number(button.dataset.d17Quantity))));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
  const carousel = document.querySelector('[data-d8-marquee]');
  if (!carousel) return;
  let dragging = false, originX = 0, originScroll = 0;
  carousel.addEventListener('pointerdown', event => {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    dragging = true; originX = event.clientX; originScroll = carousel.scrollLeft;
    carousel.setPointerCapture(event.pointerId); carousel.setAttribute('data-dragging', '');
  });
  carousel.addEventListener('pointermove', event => {
    if (dragging) carousel.scrollLeft = originScroll - (event.clientX - originX);
  });
  const stop = () => { dragging = false; carousel.removeAttribute('data-dragging'); };
  carousel.addEventListener('pointerup', stop);
  carousel.addEventListener('pointercancel', stop);
  carousel.addEventListener('lostpointercapture', stop);
})();
